import Modal, { ModalProps } from "../Modal/Modal";
import { useTranslation } from "react-i18next";
import Button from "@/Components/Button/Button";
import usePosOrderRemarkAtom from "@/shared/atoms/usePosOrderRemarkAtom";
import Textarea from "../Input/Textarea";
import ModalTitle from "../Modal/ModalTitle";
import { useForm } from "react-hook-form";
import ModalAction from "../Modal/ModalAction";
import { useRef } from "react";
import useFocusAndCursorToEnd from "@/shared/hooks/useFocusAndCursorToEndHook";

const PosOrderRemarkModal = ({ onExit, ...props }: ModalProps) => {
  const ref = useRef<HTMLTextAreaElement>(null);
  const [remark, setRemark] = usePosOrderRemarkAtom();
  const { register, handleSubmit, errors } = useForm();
  const { t } = useTranslation();
  useFocusAndCursorToEnd(ref);

  const onSubmit = ({ remark }) => {
    setRemark(remark);
    onExit();
  };

  return (
    <Modal width="40rem" onExit={onExit} {...props}>
      <ModalTitle>{t("posOrders.enterYourComment")}</ModalTitle>
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-8">
        <Textarea
          className="w-full"
          name="remark"
          defaultValue={remark}
          label={t("posOrders.enterYourComment")}
          ref={(e) => {
            register(e, {});
            ref.current = e;
          }}
          error={errors?.remark?.message}
          rows="4"
        />
        <ModalAction>
          <Button>{t("posOrders.save")}</Button>
        </ModalAction>
      </form>
    </Modal>
  );
};

export default PosOrderRemarkModal;
